import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreateEventType = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Event Type" }));
  const history = useHistory();
  const [name, setName] = useState('');
  const [point, setPoint] = useState('');
  const [descriptionTH, setDescriptionTH] = useState('');
  const [descriptionEN, setDescriptionEN] = useState('');
  const [start_date, setStart_date] = useState('');
  const [end_date, setEnd_date] = useState('');
  const [quota_member, setQuota_member] = useState('');
  const [quota_member_per_day, setQuota_member_per_day] = useState(0);
  const [quota_member_per_week, setQuota_member_per_week] = useState(0);
  const [quota_member_per_month, setQuota_member_per_month] = useState(0);
  const [quota_member_per_year, setQuota_member_per_year] = useState(0);
  const [quota_period, setQuota_period] = useState('');
  const [is_active, setIs_active] = useState('1');
  const [symbolsArr] = useState(["e", "E", "+", "-"])


  const { user } = useSelector((state) => state.auth);

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/topiclist?page=1&limit=10000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        //setListTopic(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };


  useEffect(() => {

  }, []);

  /*const handleChangeGroup = (event) => {
    console.log(event.target.value)
    setgroupID(event.target.value);
  };

  const handleChangeProduct = (event) => {
    console.log(event.target.value)
    setproductID(event.target.value);
  };*/

  const onSubmit = async () => {
    if (name === undefined || name === '') {
      return AlertError("กรุณาใส่ชื่อกิจกรรม !!");
    }
    if (point === undefined || point === '') {
      return AlertError("กรุณาใส่คะแนนที่ได้รับ !!");
    }
    if (descriptionTH === undefined || descriptionTH === '') {
      return AlertError("กรุณาใส่รายละเอียดภาษาไทย !!");
    }
    if (descriptionEN === undefined || descriptionEN === '') {
      return AlertError("กรุณาใส่รายละเอียดภาษาอังกฤษ !!");
    }
    if (start_date === undefined || start_date === '') {
      return AlertError("กรุณาใส่วันที่เริ่มกิจกรรม !!");
    }
    if (end_date === undefined || end_date === '') {
      return AlertError("กรุณาใส่วันที่สิ้นสุดกิจกรรม !!");
    }
    if (quota_member === undefined || quota_member === '') {
      return AlertError("จำนวนการสแกนทั้งหมด/คน/ตลอดกิจกรรม !!");
    }
    /*if (quota_member_per_day === undefined || quota_member_per_day === '') {
      return AlertError("จำนวนการสแกน/คน/วัน !!");
    }
    if (quota_member_per_week === undefined || quota_member_per_week === '') {
      return AlertError("จำนวนการสแกน/คน/สัปดาห์ !!");
    }
    if (quota_member_per_month === undefined || quota_member_per_month === '') {
      return AlertError("จำนวนการสแกน/คน/เดือน !!");
    }
    if (quota_member_per_year === undefined || quota_member_per_year === '') {
      return AlertError("จำนวนการสแกน/คน/ปี !!");
    }*/
    if (quota_period === undefined || quota_period === '') {
      return AlertError("จำนวนการเข้าร่วมกิจกรรมทั้งหมด !!");
    }
    var events = {
      name: name,
      point: point,
      description_th: descriptionTH,
      description_en: descriptionEN,
      start_date: start_date,
      end_date: end_date,
      quota_member: quota_member,
      quota_member_per_day: quota_member_per_day,
      quota_member_per_week: quota_member_per_week,
      quota_member_per_month: quota_member_per_month,
      quota_member_per_year: quota_member_per_year,
      quota_period: quota_period,
      is_active: is_active,

    };

    let apiUrls = `${baseURLV1}/eventType`;
    //let token = localStorage.getItem("Token");
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง event type. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Create Event Type"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อกิจกรรม" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <div>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <p style={{ position:'absolute' ,marginTop:'5px' , color: 'red'}}>*ต้องเป็นค่าเดียวกันทั้งฝั่ง Application และฝั่ง Webview</p>
            </div>
            
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "คะแนนที่ได้รับ" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={point}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setPoint(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียด (TH)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <textarea

              name="topic"
              style={{
                resize: 'none',
                height: "150px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionTH}
              onChange={(e) => setDescriptionTH(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียด (EN)" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <textarea

              name="topic"
              style={{
                resize: 'none',
                height: "150px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionEN}
              onChange={(e) => setDescriptionEN(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่เริ่มกิจกรรม" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setStart_date(data.target.value === "NULL" ? null : data.target.value)
                }
              />
            </div>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่สิ้นสุดกิจกรรม" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <div className="form-inline" style={{ marginBottom: "25px" }}>
              <input id="datestart" type="datetime-local" defaultValue="yyyy-mm-dd" style={{ height: "38px", width: "185px", backgroundColor: "#F4F6F9", borderRadius: "5px", borderWidth: "0" }}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(data) =>
                  setEnd_date(data.target.value === "NULL" ? null : data.target.value)
                }
              />
            </div>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: " จำนวนการเข้าร่วมกิจกรรม / คน" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_member}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_member(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนการเข้าร่วมกิจกรรม / คน / วัน" })}:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_member_per_day}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_member_per_day(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนการเข้าร่วมกิจกรรม / คน / สัปดาห์" })}:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_member_per_week}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_member_per_week(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนการเข้าร่วมกิจกรรม / คน / เดือน" })}:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_member_per_month}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_member_per_month(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนการเข้าร่วมกิจกรรม / คน / ปี" })}:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_member_per_year}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_member_per_year(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "จำนวนการเข้าร่วมกิจกรรมทั้งหมด" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
            </p>
            <input
              type={'number'}
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={quota_period}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  setQuota_period(e.target.value)
                }
              }}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "สถานะการใช้งาน" })}:{" "}
            </p>
            <select name="cars" id="cars"
              value={is_active}
              onChange={(e) => {
                console.log(e.target.value)
                setIs_active(e.target.value)
              }}
            >
              <option value={`1`}>
                Active
              </option>
              <option value={`0`}>
                InActive
              </option>
            </select>
          </div>

          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/EventType">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
};
